import WirePayeesPage from "components/pages/WirePayeesPage";

/**
 * @name CaptureWirePayees
 * @returns {React.Component}
 * @description - A capture in capture group "Wire Payees".
 */
export default function CaptureWirePayees(props) {
    return <WirePayeesPage/>;
}